import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
// import { AriaDirective } from '../../../shared-components/directives/aria.directive';
// import { detailExpand } from '../../../shared-components/angular-material/mat-animations';
import { HealthService } from '../health.service';
// import { Screening } from '../health.model';
import { DentalScreening, HearingScreening, PhysicalScreening, SpinalScreening, VisionScreening } from '../../../shared-modules/student-health-shared/student-health-shared.model';
import { StudentHealthSharedService } from '../../../shared-modules/student-health-shared/student-health-shared.service';
import { Observable, forkJoin } from 'rxjs';
import { take } from 'rxjs/operators';
import { StudentService } from '../../../shared-components/student/student.service';
import { YearService } from '../../../shared-components/year/year.service';

@Component({
  selector: 'app-screening',
  templateUrl: './screening.component.html',
  styleUrls: ['./screening.component.css']
})
export class ScreeningComponent implements OnInit, OnChanges {

  @Input() selectedStudent;
  isBusy = false;
  // screening: Screening[] = [];
  // screeningSelected: boolean[] = [];


  hearingScreenings: HearingScreening[] = [];
  dentalScreenings: DentalScreening[] = [];
  physicalScreenings: PhysicalScreening[] = [];
  spinalScreenings: SpinalScreening[] = [];
  visionScreenings: VisionScreening[] = [];

  hearingDataSource = new TylerMatTableDataSource();
  spinalDataSource = new TylerMatTableDataSource();
  physicalDataSource = new TylerMatTableDataSource();
  dentalDataSource = new TylerMatTableDataSource();
  visionDataSource = new TylerMatTableDataSource();
  hearingColumnsToDisplay = ['ScreeningName', 'ScreeningSeries', 'ScreenedOn', 'Results', 'ScreenedBy'];
  spinalColumnsToDisplay = ['ScreeningName', 'ScreeningSeries', 'ScreenedOn', 'Results', 'ScreenedBy'];
  physicalColumnsToDisplay = ['ScreeningName', 'ScreeningSeries', 'ScreenedOn', 'Results', 'ScreenedBy'];
  dentalColumnsToDisplay = ['ScreeningName', 'ScreeningSeries', 'ScreenedOn', 'Results', 'ScreenedBy'];
  visionColumnsToDisplay = ['ScreeningName', 'ScreeningSeries', 'ScreenedOn', 'Results', 'ScreenedBy'];

  // ----------Angular Material------------------------------------
  // angularMatData = new TylerMatTableDataSource();
  // displayedScreeningColumn = ['More', 'ScreeningType'];
  @ViewChild('hearingSort') set hearingSort(val: MatSort) {
    if (this.hearingDataSource) {
      this.hearingDataSource.sort = val;
    }
  }
  @ViewChild('spinalSort') set spinalSort(val: MatSort) {
    if (this.spinalDataSource) {
      this.spinalDataSource.sort = val;
    }
  }
  @ViewChild('physicalSort') set physicalSort(val: MatSort) {
    if (this.physicalDataSource) {
      this.physicalDataSource.sort = val;
    }
  }
  @ViewChild('dentalSort') set dentalSort(val: MatSort) {
    if (this.dentalDataSource) {
      this.dentalDataSource.sort = val;
    }
  }
  @ViewChild('visionSort') set visionSort(val: MatSort) {
    if (this.visionDataSource) {
      this.visionDataSource.sort = val;
    }
  }

  constructor(
    // private healthService: HealthService,
    private studentHealthSharedService: StudentHealthSharedService,
    private studentService: StudentService,
    private yearService: YearService) {

    // this.angularMatData = new TylerMatTableDataSource(this.screening);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedStudent.previousValue != undefined) {
      if (changes.selectedStudent.currentValue.Id != changes.selectedStudent.previousValue.Id) {
        this.getScreenings();
      }
    }
  }

  ngOnInit() {
    this.getScreenings();
  }

  getScreenings() {
    this.hearingScreenings = [];
    this.spinalScreenings = [];
    this.physicalScreenings = [];
    this.dentalScreenings = [];
    let serverCalls: Observable<any>;

    serverCalls = forkJoin(
      this.studentHealthSharedService.getHearingScreeningReadByStudentId(this.studentService.selectedStudent.Id, this.yearService.defaultYear.SchoolID, this.yearService.defaultYear.Id),
      this.studentHealthSharedService.getSpinalScreeningReadByStudentId(this.studentService.selectedStudent.Id, this.yearService.defaultYear.SchoolID, this.yearService.defaultYear.Id),
      this.studentHealthSharedService.getPhysicalScreeningReadByStudentId(this.studentService.selectedStudent.Id, this.yearService.defaultYear.SchoolID, this.yearService.defaultYear.Id),
      this.studentHealthSharedService.getDentalScreeningReadByStudentId(this.studentService.selectedStudent.Id, this.yearService.defaultYear.SchoolID, this.yearService.defaultYear.Id),
      this.studentHealthSharedService.getVisionScreeningReadByStudentId(this.studentService.selectedStudent.Id, this.yearService.defaultYear.SchoolID, this.yearService.defaultYear.Id)
    );

    serverCalls.pipe(take(1)).subscribe(results => {
      this.hearingScreenings = results[0];
      this.spinalScreenings = results[1];
      this.physicalScreenings = results[2];
      this.dentalScreenings = results[3];
      this.visionScreenings = results[4];
      this.hearingDataSource = new TylerMatTableDataSource(this.hearingScreenings);
      this.spinalDataSource = new TylerMatTableDataSource(this.spinalScreenings);
      this.physicalDataSource = new TylerMatTableDataSource(this.physicalScreenings);
      this.dentalDataSource = new TylerMatTableDataSource(this.dentalScreenings);
      this.visionDataSource = new TylerMatTableDataSource(this.visionScreenings);
      this.hearingDataSource.sort = this.hearingSort;
      this.spinalDataSource.sort = this.spinalSort;
      this.physicalDataSource.sort = this.physicalSort;
      this.dentalDataSource.sort = this.dentalSort;
      this.visionDataSource.sort = this.visionSort;
    });
  }
}
